import { invokeApi } from "../bl_libs/invokeApi";

export const get_messages_api = async (conversation_id) => {
  const requestObj = {
    path: `api/messages/list/${conversation_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
